module.exports = __webpack_public_path__ + "static/img/li1_5.c6ed2634.png";